import { useState } from "react";

export default function usePersistedStateOnDemand<T>(
  key: string,
  initialValue: T
): [T, React.Dispatch<React.SetStateAction<T>>, () => void, () => void] {
  const [state, setState] = useState<T>(() => {
    try {
      const stored = localStorage.getItem(key);
      return stored ? (JSON.parse(stored) as T) : initialValue;
    } catch (err) {
      console.error(`Erro ao carregar ${key} do localStorage:`, err);
      return initialValue;
    }
  });

  // grava somente quando você chamar
  const persist = () => {
    try {
      localStorage.setItem(key, JSON.stringify(state));
    } catch (err) {
      console.error(`Erro ao salvar ${key} no localStorage:`, err);
    }
  };

  // opcional: limpar a chave
  const clear = () => {
    try {
      localStorage.removeItem(key);
    } catch {}
  };

  return [state, setState, persist, clear];
}
